export enum baseChargeThresholdAction {
  noAction = "noAction",
  applyChargeIfHigher = "applyChargeIfHigher",
  applyChargeIfLower = "applyChargeIfLower",
  removeChargeIfHigher = "removeChargeIfHigher",
  removeChargeIfLower = "removeChargeIfLower",
}
